import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {BehaviorSubject, combineLatest, filter, first, firstValueFrom} from 'rxjs';
import {MmFaultsLoaderService} from '../../mm-faults-loader.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Structure} from '@docma-mm-core/structure/structure';
import {MmProjectLoaderService} from '../../../mm-project/mm-project-loader.service';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {Activity} from '@docma-mm-core/activity/activity';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {getOverallStateByFault, getOverallStateBySync, OverallSyncStatus} from '../../sync-status.util';
import {ProjectActionPermissionEnum} from '@docma-mm-core/permission/project-action-permission.enum';
import {MmProjectPermissionsService} from '../../../mm-project/mm-project-permissions-service';
import {MmFaultRightPanePageEnum} from '../../mm-faults-view/mm-fault-right-pane/mm-fault-right-pane.enum';
import {ConnectivityService, FullscreenService} from '@mydocma/core';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {TranslateService} from '@ngx-translate/core';
import {MydocmaPromptButtonTypeEnum, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MmFaultRightPaneService} from '../../mm-faults-view/mm-fault-right-pane/mm-fault-right-pane.service';
import {MmFaultChangePageService} from '../../mm-faults-view/mm-fault-right-pane/mm-fault-change-page.service';
import {ReportService} from '../../../mm-reporting/faults/faults-reports/reports.service';
import {MmFaultsWritingReportingService} from '../../../mm-reporting/faults/faults-writing/mm-fault-writing-reporting.service';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ViewPoint} from '@docma-mm-core/status/viewpoint.enum';
import {CategoryEnum, Status} from '@docma-mm-core/status/status';
import {map, switchMap, take, tap} from 'rxjs/operators';
import {getIconName, Shortcut} from '@docma-mm-core/shortcut/shortcut';
import {FaultViewEnum, MmFaultViewService} from '../../mm-fault/mm-fault-view.service';
import {PersonalizationService} from '@docma-mm-core/personalization/personalization.service';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {MmFaultsViewService} from '../../mm-faults-view/services/mm-faults-view.service';
import {SyncStatusEnum} from '@docma-mm-core/model/sync-state/sync-status.enum';
import {MmFaultActionsService} from '../../mm-fault-actions.service';
import {ConfigProvider} from '@mydocma/common';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {BpPinLocationTargetEnum} from '../../../bp-common/models/bp-pin';
import {FieldPropertyEnum} from '@docma-mm-core/field/field-property.enum';
import {FieldPermission} from '@docma-mm-core/field/field-permission.enum';
import {SizeModeEnum} from '../size-mode.enum';
import {AttachmentType} from '@docma-mm-core/attachment/attachment-type';
import {Attachment, AttachmentSource} from '@docma-mm-core/attachment/attachment';
import {MmImageViewerService} from '../../../mm-image-viewer.service';
import {ViewerItem} from '@mydocma/component-library/src/lib/image-viewer';
import {MmPinDragDropService} from '../../../mm-drag-drop/mm-pin-drag-drop/mm-pin-drag-drop.service';
import Hammer from 'hammerjs';
import {AppContainerService, AppRightPaneService} from '@mydocma/app-container';
import {MmBimService} from '../../../mm-bim/mm-bim.service';
import {MmPlansManagerService} from '../../mm-plans-view/services/mm-plans-manager.service';
import {PinPopupService} from '@mydocma/tile-viewer';

@UntilDestroy()
@Component({
  selector: 'mm-fault-tile-extended',
  templateUrl: './mm-fault-tile-extended.component.html',
  styleUrls: ['./mm-fault-tile-extended.component.scss'],
})
export class MmFaultTileExtendedComponent implements OnInit, OnChanges, OnDestroy {
  @Output() menuStateToggle = new EventEmitter<boolean>();
  @Output() onCloseButtonClicked = new EventEmitter();
  @Input() showCloseButton: boolean;
  @Input() fault: ViewFault;
  @Input() fieldPermDict: { [prop: string]: FieldPermission };
  @Input() sizeMode: SizeModeEnum = SizeModeEnum.Normal;
  @Input() isSelected: boolean = false;
  @Input() isChecked: boolean;
  @Input() selectionMode: boolean = false;
  @Input() initAsPlanViewerPopup: boolean = false;

  @ViewChild('openFileSystem') fileSystemLabel: ElementRef;

  loader: NodeJS.Timeout;
  loadState = LoadStatusEnum;
  syncState = SyncStatusEnum;
  isInitialized = false;
  isLoaded = false;

  minTileHeight = 168;
  isHovered = false;

  structurePath: string;
  structures: MmModel<Structure[]>;
  companyName: string;
  craftName: string;
  lastActivitySC: Activity;
  lastActivityCT: Activity;
  delayGroupSC: SafeUrl;
  delayGroupSCImageName: string;
  delayGroupCT: SafeUrl;
  delayGroupCTImageName: string;
  allAttachments: Attachment[] = [];


  readonly overallSyncStatusEnum = OverallSyncStatus;
  overallSyncStatus: OverallSyncStatus

  readonly changeStatusEnum = ChangeStatusEnum;
  readonly sizeModesEnum = SizeModeEnum;
  readonly loadStatusEnum = LoadStatusEnum;
  readonly attachmentTypes = AttachmentType;

  maxCountFaultsNewActivity: number;
  private pinPopupService: PinPopupService;

  get isLocked() {
    return ((this.fault?.loadState?.data?.IsLocked ?? this.fault?.isLocked) ?? false);
  }

  permissionDelete$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeleteFault]);
  permissionDeletePins$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeletePins]);

  companies$ = this.projectLoaderService.companies.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data));
  crafts$ = this.projectLoaderService.crafts.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data));
  delays$ = this.projectLoaderService.delays.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data));
  userPermissions$ = this.projectLoaderService.projectUserPermissions.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded)).pipe(map(x => x.data));
  lockedStatus$ = this.projectLoaderService.statuses.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data.filter(x => !!x.IsLocked)));

  hasCompanyPermission = false;
  hasCraftPermission = false;

  faultsStateSubject = new BehaviorSubject<{ IsAnyFaultLocked: boolean, SelectedFaultsCount: number }>({
    IsAnyFaultLocked: false,
    SelectedFaultsCount: 0
  });
  faultsState$ = this.faultsStateSubject.asObservable();

  preventClick = false;

  attachmentLeft: Attachment;
  attachmentRight: Attachment;

  private attachmentLeftSubject = new BehaviorSubject<{ Source: AttachmentSource, Attachment: Attachment }>(null);
  attachmemntLeft$ = new BehaviorSubject<{ Source: AttachmentSource, Attachment: Attachment }>(null);

  private attachmentRightSubject = new BehaviorSubject<{ Source: AttachmentSource, Attachment: Attachment }>(null);
  attachmemntRight$ = new BehaviorSubject<{ Source: AttachmentSource, Attachment: Attachment }>(null);

  guid = Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);


  constructor(private faultsLoaderService: MmFaultsLoaderService,
              private readonly projectLoaderService: MmProjectLoaderService,
              private readonly faultSyncService: FaultSyncService,
              private readonly faultService: FaultService,
              public readonly permissionService: MmProjectPermissionsService,
              private readonly connectivityService: ConnectivityService,
              private readonly notificationService: NotificationService,
              private readonly translateService: TranslateService,
              private readonly dialogService: PromptDialogService,
              readonly rightPaneService: MmFaultRightPaneService,
              readonly changeService: MmFaultChangePageService,
              private readonly writingService: MmFaultsWritingReportingService,
              private reportService: ReportService,
              private readonly sanitizer: DomSanitizer,
              private readonly personilizationService: PersonalizationService,
              readonly faultViewService: MmFaultViewService,
              readonly faultsViewService: MmFaultsViewService,
              private readonly selectionService: SelectionService<ViewFault>,
              public readonly faultActionsService: MmFaultActionsService,
              private configService: ConfigProvider<IMmConfig>,
              private readonly pinDragDropService: MmPinDragDropService,
              private readonly nativeElement: ElementRef,
              public appContainerService: AppContainerService,
              private appRightPaneService: AppRightPaneService,
              public fullScreenService: FullscreenService,
              private readonly loaderService: MmFaultsLoaderService,
              private readonly imageViewerService: MmImageViewerService,
              private bimService: MmBimService,
              private changeDetectorRef: ChangeDetectorRef,
              readonly plansManagerService: MmPlansManagerService) {

    this.maxCountFaultsNewActivity = this.configService.getConfigData().mmConfig.maxCountFaultsNewActivity;

    this.selectionService.selectedItems.pipe(untilDestroyed(this)).subscribe(faults => {
      const isAnyFaultLocked: boolean = (faults.findIndex(f => f.layoutState.data.IsLocked === true) !== -1);
      this.faultsStateSubject.next({IsAnyFaultLocked: isAnyFaultLocked, SelectedFaultsCount: faults.length});
    });

    this.projectLoaderService.project
      .pipe(untilDestroyed(this), filter(x => x.loadState.status === LoadStatusEnum.Loading))
      .subscribe(() => {
        this.fault = undefined;
      });
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes.fieldPermDict) {
      this.hasCompanyPermission = this.getCompanyPermission();
      this.hasCraftPermission = this.getCraftPermission();
    }

    if (changes.sizeMode) {
      this.setMinTileHeight();
    }

    if (!changes.fault?.currentValue?.loadState) {
      // console.warn('loadState NULL');
      return;
    }

    if (changes.fault.currentValue.loadState.status === LoadStatusEnum.NotLoaded) {
      // delay loading a plan to prevent hundreds of faults getting loaded when scrolling through tile
      if (!this.initAsPlanViewerPopup) {
        this.loader = setTimeout(() => this.loadFault(), 100);
      } else {
        this.loadFault();
      }
    } else {
      try {
        await Promise.all([
          this.loadBaseData(this.fault),
          this.loadStructure(this.fault),
          this.loadLastActivities(this.fault)
        ]);
        this.changeDetectorRef.detectChanges();

        // setTimeout to make sure view updated

        // setTimeout(() => {
          this.pinPopupService?.updateMarkerPopup(this.fault.identifier);
        // }, 0);
      } catch (e) {
        console.error(`an error${e} occurred while loading fault`);
      }


      // combineLatest([of(this.fault), this.fault?.loadState$])
      //   .pipe(untilDestroyed(this))
      //   .subscribe(([f, ls]) => {
      //     console.warn('STATE:');
      //     console.warn(f);
      //     console.warn(ls);
      //     console.warn(this.isInitialized);
      //   })
    }
  }

  async ngOnInit() {
    // console.warn('EXTENDED TILE ngOnInit');
    // console.warn(this.fault);

    if (!this.isInitialized && !!this.fault?.unsavedNew) {
      this.isInitialized = true;
    }

    // this.setMinTileHeight();

    this.faultsLoaderService.onFaultLoaded
      .pipe(untilDestroyed(this))
      .subscribe(async (f) => {
        if (f.uid === this.fault?.uid) {
          await Promise.all([this.loadBaseData(this.fault), this.loadStructure(this.fault), this.loadLastActivities(this.fault)])

          this.overallSyncStatus = getOverallStateByFault(f, this.fault, this.faultService);
          // setTimeout(() => {
            this.pinPopupService?.updateMarkerPopup(this.fault.identifier);
            this.isInitialized = true;
          // }, 0);

        }
      });

    this.faultsLoaderService.onLayoutFaultsLoaded.pipe(untilDestroyed(this))
      .subscribe(async f => {
        const found = f.find(x => x.uid === this.fault?.uid);
        if (found) {
          this.updateLocked(this.fault);
        }
      });

    this.faultsLoaderService.onActivitiesDeleted.pipe(untilDestroyed(this))
      .subscribe(async activities => {
        let updateActivities = false;

        await Promise.all(activities.map(async activity => {
          if (activity.fault.uid === this.fault?.uid) {
            updateActivities = true;
            const found = this.fault?.activities?.findIndex(a => a.uid === activity.uid);
            if (found !== -1) {
              this.fault.activities.splice(found, 1);
            }
          }
        }));

        if (updateActivities) {
          this.loadLastActivities(this.fault);
        }
      });

    this.faultsLoaderService.onAttachmentDeleted.pipe(untilDestroyed(this))
      .subscribe(args => {
        if (args.fault.uid === this.fault?.uid) {
          this.loadAttachments();
        }
      })

    this.faultService.onFaultChanged.pipe(untilDestroyed(this))
      .subscribe(f => {
        if (f.uid === this.fault?.uid) {
          this.overallSyncStatus = getOverallStateByFault(f, this.fault, this.faultService);
          this.loadBaseData(this.fault);
          this.loadStructure(this.fault);
          this.loadLastActivities(this.fault);
        }
      });

    this.faultSyncService.syncFaultsState$
      .pipe(untilDestroyed(this))
      .subscribe(state => {
        this.loadBaseData(this.fault);
        this.loadStructure(this.fault);
        this.overallSyncStatus = getOverallStateBySync(state.changes, this.fault);
        this.isInitialized = true;
      });

    let touchEventManager = new Hammer(this.nativeElement.nativeElement, {inputClass: Hammer.TouchInput});
    touchEventManager.get('press').set({time: 200})
    touchEventManager.on('press', this.onPress.bind(this));
    touchEventManager.on('pressup', this.onPressUp.bind(this));
  }

  setMinTileHeight() {
    let minHeight = 168 - 4;

    if (this.hasCompanyPermission) {
      minHeight += 24;
    }
    if (this.hasCraftPermission) {
      minHeight += 24;
    }
    if (this.sizeMode == SizeModeEnum.Narrow && !this.initAsPlanViewerPopup) {
      minHeight += 128;
    }
    this.minTileHeight = minHeight;
  }

  getCompanyPermission() {
    return this.fieldPermDict.hasOwnProperty(FieldPropertyEnum.Company.toString()) && this.fieldPermDict[FieldPropertyEnum.Company.toString()] !== FieldPermission.None;
  }

  getCraftPermission() {
    return this.fieldPermDict.hasOwnProperty(FieldPropertyEnum.Craft.toString()) && this.fieldPermDict[FieldPropertyEnum.Craft.toString()] !== FieldPermission.None;
  }


  async loadFault() {
    combineLatest([this.faultsLoaderService.loadFaults([this.fault])
      , this.projectLoaderService.structures.pipe(filter(st => st.loadState.status === LoadStatusEnum.Loaded))])
      .pipe(untilDestroyed(this))
      .subscribe(async ([faults, structures]) => {
        try {
          if (!this.fault) {
            return;
          }

          this.structures = structures;
          await Promise.all([this.loadBaseData(this.fault), this.loadStructure(this.fault), this.loadLastActivities(this.fault)]);
          // setTimeout(() => {
            this.pinPopupService?.updateMarkerPopup(this.fault.identifier);
            this.isInitialized = true;
          // }, 0);
        } catch (e) {
          console.error(`an error${e} occurred while loading fault`);
        }
      });
  }

  isFaultLoaded(f: ViewFault) {
    const isNotLoaded = (Object.keys(f.data).length === ["IsLocked", "Attribute"].length &&
      Object.keys(f.data).every((v, i) => v === ["IsLocked", "Attribute"][i]));

    return !isNotLoaded;
  }

  async loadBaseData(f: ViewFault) {
    if (f?.data?.Company) {
      const co = (await firstValueFrom(this.companies$)).find(x => x.Id === f.data.Company.Id);
      this.companyName = `${co?.ShortName}${(co?.Name1 ? ' - ' : '') + (co?.Name1 ?? '')}`;
    } else {
      this.companyName = undefined;
    }
    if (f?.data?.Craft) {
      const cr = (await firstValueFrom(this.crafts$)).find(x => x.Id === f.data.Craft.Id);
      this.craftName = `${cr?.Name1}${(cr?.Name2 ? ' - ' : '') + (cr?.Name2 ?? '')}`;
    } else {
      this.craftName = undefined;
    }

    if (this.fault && this.isFaultLoaded(this.fault)) {
      await this.loadAttachments();
      this.isLoaded = true;
    }
  }

  async loadAttachments() {
    if (this.appContainerService.isMobileView && this.initAsPlanViewerPopup) {
      return;
    }

    this.allAttachments = [];

    this.fault.attachments.filter(x => x.loadState.status === LoadStatusEnum.Loaded && (x.data.Type === AttachmentType.Picture || x.data.Type === AttachmentType.PlanSection)).forEach(att => {
      this.allAttachments.push(att);
    });
    this.fault.activities.forEach(a => {
      a.attachments.filter(x => x.loadState.status === LoadStatusEnum.Loaded && x.data.Type === AttachmentType.Picture).forEach(att => {
        this.allAttachments.push(att);
      });
    });

    const sortedPictures = this.allAttachments
      .filter(x => x.data.Type === AttachmentType.Picture)
      .sort((a, b) => b.data.Date.getTime() - a.data.Date.getTime() || b.data.Id - a.data.Id);

    const sortedPlanSections = this.allAttachments
      .filter(x => x.data.Type === AttachmentType.PlanSection)
      .sort((a, b) => b.data.Date.getTime() - a.data.Date.getTime() || b.data.Id - a.data.Id);

    if (sortedPictures.length > 0 && sortedPlanSections.length > 0) {
      this.attachmentLeft = (this.initAsPlanViewerPopup ? undefined : sortedPlanSections[0]);
      this.attachmentRight = sortedPictures[0];
    } else if (sortedPictures.length > 0 && sortedPlanSections.length == 0) {
      if (sortedPictures.length > 1) {
        this.attachmentLeft = (this.initAsPlanViewerPopup ? undefined : sortedPictures[0]);
        this.attachmentRight = (this.initAsPlanViewerPopup ? sortedPictures[1] : sortedPictures[0]);
      } else {
        delete this.attachmentLeft;
        this.attachmentRight = sortedPictures[0];
      }
    } else if (sortedPlanSections.length > 0 && sortedPictures.length == 0) {
      if (sortedPlanSections.length > 1) {
        this.attachmentLeft = (this.initAsPlanViewerPopup ? undefined : sortedPlanSections[0]);
        this.attachmentRight = (this.initAsPlanViewerPopup ? undefined : sortedPlanSections[1]);
      } else {
        delete this.attachmentLeft;
        this.attachmentRight = (this.initAsPlanViewerPopup ? undefined : sortedPlanSections[0]);
      }
    } else {
      delete this.attachmentLeft;
      delete this.attachmentRight;
    }

    if (this.attachmentLeft) {
      await this.loaderService.loadAttachmentThumbnail(this.fault, this.attachmentLeft, {height: 600, width: 600});

      this.attachmentLeft.thumbnail$.pipe(tap(t => this.attachmemntLeft$.next({
          Source: t,
          Attachment: this.attachmentLeft
        }))
        , switchMap(t => t.loadState$.pipe(map(l => ({attachment: this.attachmentLeft, source: t}))))
        , untilDestroyed(this))
        .subscribe(param => {
          this.attachmemntLeft$.next({Source: param.source, Attachment: param.attachment});
        });
    } else {
      this.attachmemntLeft$.next(null);
    }

    if (this.attachmentRight) {
      await this.loaderService.loadAttachmentThumbnail(this.fault, this.attachmentRight, {height: 600, width: 600});

      this.attachmentRight.thumbnail$.pipe(tap(t => this.attachmemntRight$.next({
          Source: t,
          Attachment: this.attachmentRight
        }))
        , switchMap(t => t.loadState$.pipe(map(l => ({attachment: this.attachmentRight, source: t}))))
        , untilDestroyed(this))
        .subscribe(param => {
          this.attachmemntRight$.next({Source: param.source, Attachment: param.attachment});
        });
    } else {
      this.attachmemntRight$.next(null);
    }
  }

  async loadStructure(f: ViewFault) {
    if (f?.loadState?.status === LoadStatusEnum.Loaded) {
      if (!this.structures) {
        this.structures = await firstValueFrom(this.projectLoaderService.structures.pipe(filter(st => st.loadState.status === LoadStatusEnum.Loaded)));
      }

      const foundStructure = this.structures?.data[0].findById(this.fault.data.Structure.Id);
      if (foundStructure) {
        if (this.structures.data[0].Id !== this.fault.data.Structure.Id) {
          this.structurePath = `${foundStructure.StructurePathShort.slice(foundStructure.StructurePathShort.indexOf('\\') + 2, foundStructure.StructurePathShort.length)} - ${foundStructure.Name2}`;
        } else {
          this.structurePath = `${foundStructure.StructurePathShort} - ${foundStructure.Name2}`;
        }
      }
    }
  }

  async loadLastActivities(f: ViewFault) {
    if (f?.loadState?.status === LoadStatusEnum.Loaded) {
      this.updateActivitiesFlags(f);
      this.lastActivitySC = f.activities.filter(x => x.data.Status.ViewPoint === 1 && x.data.IsLastOfViewPoint)[0];
      this.lastActivityCT = f.activities.filter(x => x.data.Status.ViewPoint === 2 && x.data.IsLastOfViewPoint)[0];
      await Promise.all([this.updateDelays(), this.updateLocked(f)]);

    }
  }

  updateActivitiesFlags(f: ViewFault) {
    let activitiesPerStatus: { [uid: string]: Activity[] } = f?.activities
      .reduce((acc, curr) => {
        const currGrp = `${curr.fault.uid}###${curr.data.Status.Id}`;
        if (currGrp) {
          if (acc[currGrp] == null) {
            acc[currGrp] = [];
            acc[currGrp].push(curr);
          } else {
            acc[currGrp].push(curr);
          }
        }
        return acc;
      }, {});

    let activitiesPerViewPoint: { [uid: string]: Activity[] } = f?.activities
      .reduce((acc, curr) => {
        const currGrp = `${curr.fault.uid}###${+curr.data.Status.ViewPoint}`;
        if (currGrp && (curr.data.Status.IsNeutral ?? false) === false) {
          if (acc[currGrp] == null) {
            acc[currGrp] = [];
            acc[currGrp].push(curr);
          } else {
            acc[currGrp].push(curr);
          }
        }
        return acc;
      }, {});

    Object.keys(activitiesPerStatus).forEach(key => {
      const activitiesAsc = [...activitiesPerStatus[key]].sort((a, b) => +a.data.Date - +b.data.Date || +a.data.CreatedOn - +b.data.CreatedOn);
      const activitiesDesc = [...activitiesPerStatus[key]].sort((a, b) => +b.data.Date - +a.data.Date || +b.data.CreatedOn - +a.data.CreatedOn);

      activitiesAsc[0].data.IsFirst = true;
      activitiesDesc[0].data.IsLast = true;

      activitiesAsc.slice(1, activitiesAsc.length).forEach(a => a.data.IsFirst = false);
      activitiesDesc.slice(1, activitiesDesc.length).forEach(a => a.data.IsLast = false);
    });

    Object.keys(activitiesPerViewPoint).forEach(key => {
      const activitiesDesc = [...activitiesPerViewPoint[key]].sort((a, b) => +b.data.Date - +a.data.Date || +b.data.CreatedOn - +a.data.CreatedOn);
      activitiesDesc[0].data.IsLastOfViewPoint = true;
      activitiesDesc.slice(1, activitiesDesc.length).forEach(a => a.data.IsLastOfViewPoint = false);
    });
  }

  async updateDelays() {
    let userViewPoint: number;

    if (!this.lastActivitySC) {
      delete this.delayGroupSC;
      delete this.delayGroupSCImageName;
    } else {
      if (!userViewPoint) {
        userViewPoint = (await firstValueFrom(this.userPermissions$)).User.Company.ViewPoint;
      }
      let delayCategory = CategoryEnum.Open;
      if (userViewPoint === ViewPoint.Contractor) {
        delayCategory = this.lastActivitySC?.data.Status.CategoryCO;
      } else if (userViewPoint === ViewPoint.Subcontractor) {
        delayCategory = this.lastActivitySC?.data.Status.CategorySC;
      }

      if (!this.lastActivitySC?.data?.DueDate && delayCategory && delayCategory === CategoryEnum.Closed) {
        delete this.delayGroupSC;
        this.delayGroupSCImageName = "_delay-resolved";
      } else if (!this.lastActivitySC?.data?.DueDate && delayCategory && delayCategory === CategoryEnum.Open) {
        delete this.delayGroupSC;
        this.delayGroupSCImageName = "_delay-no-duedate";
      } else if (!!this.lastActivitySC?.data?.DueDate) {
        if (delayCategory === CategoryEnum.Open) {
          const currentDelay = (await firstValueFrom(this.delays$)).find(x => new Date(x.CurrentMinDate) <= new Date(this.lastActivitySC.data.DueDate) && new Date(x.CurrentMaxDate) >= new Date(this.lastActivitySC.data.DueDate));
          if (currentDelay) {
            let delayURL = URL.createObjectURL(new Blob([currentDelay.DelayImage]));
            this.delayGroupSC = this.sanitizer.bypassSecurityTrustUrl(delayURL);
            delete this.delayGroupSCImageName;
          } else {
            delete this.delayGroupSC;
            this.delayGroupSCImageName = "_delay-no-duedate";
          }
        } else {
          delete this.delayGroupSC;
          this.delayGroupSCImageName = "_delay-resolved";
        }
      }
    }

    if (!this.lastActivityCT) {
      delete this.delayGroupCT;
      delete this.delayGroupCTImageName;
    } else {
      if (!userViewPoint) {
        userViewPoint = (await firstValueFrom(this.userPermissions$)).User.Company.ViewPoint;
      }
      let delayCategory = CategoryEnum.Open;
      if (userViewPoint === ViewPoint.Contractor) {
        delayCategory = this.lastActivityCT?.data.Status.CategoryCO;
      } else if (userViewPoint === ViewPoint.Customer) {
        delayCategory = this.lastActivityCT?.data.Status.CategoryCT;
      }

      if (!this.lastActivityCT?.data?.DueDate && delayCategory && delayCategory === CategoryEnum.Closed) {
        delete this.delayGroupCT;
        this.delayGroupCTImageName = "_delay-resolved";
      } else if (!this.lastActivityCT?.data?.DueDate && delayCategory && delayCategory === CategoryEnum.Open) {
        delete this.delayGroupCT;
        this.delayGroupCTImageName = "_delay-no-duedate";
      } else if (!!this.lastActivityCT?.data?.DueDate) {
        if (delayCategory === CategoryEnum.Open) {
          const currentDelay = (await firstValueFrom(this.delays$)).find(x => new Date(x.CurrentMinDate) <= new Date(this.lastActivityCT.data.DueDate) && new Date(x.CurrentMaxDate) >= new Date(this.lastActivityCT.data.DueDate));
          if (currentDelay) {
            let delayURL = URL.createObjectURL(new Blob([currentDelay.DelayImage]));
            this.delayGroupCT = this.sanitizer.bypassSecurityTrustUrl(delayURL);
            delete this.delayGroupCTImageName;
          } else {
            delete this.delayGroupCT;
            this.delayGroupCTImageName = "_delay-no-duedate";
          }
        } else {
          delete this.delayGroupCT;
          this.delayGroupCTImageName = "_delay-resolved";
        }
      }
    }
  }

  async updateLocked(f: ViewFault) {
    const lockedStatus: { [id: number]: Status } = {};
    await firstValueFrom(this.lockedStatus$.pipe(map(m => m.map(st => lockedStatus[st.Id] = st))));

    if (Object.keys(lockedStatus).length > 0) {
      f.isLocked = f.activities.some(a => lockedStatus.hasOwnProperty(a.data.Status.Id));
    }
  }

  ngOnDestroy() {
    if (this.loader) {
      // console.warn(`TIMEOUT CLEARED ### TILE fault id #${this.fault.id}`);
      clearTimeout(this.loader);
    }
  }

  suspendChangeChecked: boolean = false;

  async onClick(event) {

    if (this.preventClick) return;

    if (event.target.className.includes('checkbox') || event.target.innerText === 'close' || event.target.className.includes('add-attachment') || event.target.className.includes('add-attachment-input') || event.target.className.includes('add-attachment-icon') || event.target.className.includes('file-input')) {
      return;
    }

    const mode = await this.selectionService.selectionMode.pipe(first()).toPromise();

    if (!mode) {
      await this.faultsViewService.openRightPane(this.fault);
      //fullscreen issue related to  MMW-2668
      const fullScreenState = !!this.fullScreenService?.fullscreenElement && this.appContainerService.isMobileView;
      if (fullScreenState) {
        this.fullScreenService.exitFullscreen();

        this.appRightPaneService.isOpen.pipe(untilDestroyed(this), filter(value => !value),
          take(1)
        ).subscribe(value => {
          const elem = document.querySelector('.plans-view-container') as HTMLElement;
          this.fullScreenService.requestFullscreen(elem);
        })
      }
      const selected = await this.faultsViewService.currentFault.pipe(first()).toPromise();
      if (selected && selected.uid !== this.fault?.uid) {
        //this.selectFault(selected);
      } else {
        await this.faultsLoaderService.loadFaults([this.fault]).toPromise();
      }
    } else {
      this.suspendChangeChecked = true;
      if (!this.isChecked) {
        this.selectionService.selectItem(this.fault);
        //, !this.isChecked
      } else {
        this.selectionService.deselectItem(this.fault, false);
      }
    }
  }

  hasChanges(): boolean {
    return this.changeService.hasChanges(MmFaultRightPanePageEnum.fault) || this.changeService.hasChanges(MmFaultRightPanePageEnum.plan);
  }

  async onDeleteClick() {
    await this.faultActionsService.onDeleteClick([this.fault]);
  }

  async onCreateWritingClick() {
    await this.writingService.startReportConfiguration(this.fault.project, [this.fault.data]);
  }

  async startFaultListReport() {
    this.reportService.startReportConfiguration(this.fault.project, [this.fault.data]);
  }

  async addActivities() {
    this.addActivitiesByShortcut(null);
  }

  async addActivitiesByShortcut(shortcut: Shortcut) {
    let viewPointSelection = 1;

    const val = await this.personilizationService.getValue('LatestSelected_ActivityType');
    const ctPerm = await this.permissionService.permissionViewActivitiesCT$.pipe(take(1)).toPromise();
    const coPerm = await this.permissionService.permissionViewActivitiesCO$.pipe(take(1)).toPromise();

    if (val === 1 && ctPerm) {
      viewPointSelection = val;
    } else if (val === 2 && coPerm) {
      viewPointSelection = val;
    } else {
      viewPointSelection = 1;
    }

    this.faultViewService.requestToggleView(FaultViewEnum.NewActivity, {
      faults: [this.fault],
      selectedViewPoint: viewPointSelection,
      selectedStatus: shortcut?.Status
    });
  }

  IconName(shortcut: Shortcut): string {
    return getIconName(shortcut);
  }

  async onMenuOpened() {
    const mode = await this.selectionService.selectionMode.pipe(first()).toPromise();
    if (!mode) {
      this.selectionService.deselectRange(await firstValueFrom(this.selectionService.selectedItems.pipe(map(m => m))))
      this.selectionService.selectItem(this.fault);
    }

    this.menuStateToggle.emit(true);
  }

  onMenuClosed() {
    this.menuStateToggle.emit(false);
  }

  changeChecked(event) {
    if (event.checked) {
      if (!this.selectionMode) {
        this.selectionService.startSelectionMode();
      }

      this.selectionService.selectItem(this.fault);
    } else {
      this.selectionService.deselectItem(this.fault);
    }
  }

  async onDeletePin() {
    if (this.fault?.bpPin?.Locations.find(l => l.Type == BpPinLocationTargetEnum.bim)) {
      await this.dialogService.showPromptDialog({
        title: this.translateService.instant('MM.plan.error.bimPinCantBeRemoved.title'),
        content: this.translateService.instant('MM.plan.error.bimPinCantBeRemoved.content'),
        buttons: [{
          text: "Ok",
          type: MydocmaPromptButtonTypeEnum.primary,
          value: false
        }]
      });
      return;
    }

    const title = this.translateService.instant('MM.dialog.removePin.title')
    const content = this.translateService.instant('MM.dialog.removePin.content');

    if ((await this.dialogService.showDeleteConfirmationDialog({title, content}))?.value) {
      if (this.fault.bpPin) {
        const bimSectionPlan = this.bimService.getSectionPlan(this.bimService.selectedPlan?.id.toString());
        const plan = this.plansManagerService.selectedPlan;
        const locIndex = this.fault.bpPin.Locations.findIndex(loc => loc.Type === BpPinLocationTargetEnum.plan);  // loc.ModelId === (bimSectionPlan?.planId || plan?.id?.toString()) && loc.VersionId === (bimSectionPlan?.versionId || plan?.data?.BpPlan?.activeVersion?.id)
        if (locIndex > -1) {
          this.fault.bpPin.Locations.splice(locIndex, 1);
          this.fault.addChanges({Pin: this.fault.bpPin, ModifiedOn: new Date()});
        }
      } else {
        this.fault.addChanges({
          PlanId: this.fault?.data?.PlanId || this.fault?.pin?.FileId, ModifiedOn: new Date(),
          PlanPositionX: null, PlanPositionY: null,
          PlanRelativeAnchorToParentPositionX: null, PlanRelativeAnchorToParentPositionY: null
        });
      }

      this.fault.pin = null;
      this.fault.bpPin = null;

      if (this.fault.hasAnyChanges()) {
        await this.faultService.saveFaultChanges(this.fault.project.MyDocmaUid, this.fault);
      }
    }
  }

  async onTileClick(event, at: Attachment) {
    const className: string = event.srcElement.className;
    if (className.includes('at-thumbnail') || className.includes('attachments-hover')) {
      event.stopPropagation();
      const item = {};

      await this.imageViewerService.showInFullScreen({
        currentItem: at,
        items: this.allAttachments.filter(x => !!x), //[this.attachmentLeft, this.attachmentRight]
        itemLoader: this.imageViewerItemLoader.bind(this)
      });
    }
  }

  private async imageViewerItemLoader(attachment: Attachment): Promise<ViewerItem> {
    await this.loaderService.loadAttachmentSource(this.fault, attachment)
    await attachment.source.loadState$.pipe(
      filter(s => s && (s.status === LoadStatusEnum.Loaded || s.status === LoadStatusEnum.Error)),
      first()).toPromise();
    const viewerItem: ViewerItem = {};
    if (attachment.source.loadState.status === LoadStatusEnum.Loaded) {
      viewerItem.url = (attachment.source.url as any).changingThisBreaksApplicationSecurity;
    }
    return viewerItem;
  }

  onAddAttachmentsClick() {
    this.onFileSystemButtonClick();

  }

  public async onFileSystemButtonClick() {
    this.fileSystemLabel.nativeElement.click();
  }

  onFileInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const fileList = inputElement.files;
    const files = this.fileListToFiles(fileList)
    event.stopPropagation();
    this.faultViewService.requestToggleView(FaultViewEnum.NewFaultAttachmentFromFile, {
      fault: this.fault,
      files: files
    });
    inputElement.value = null;
  }

  private fileListToFiles(fileList: FileList): File[] {
    const files = []
    for (let i = 0; i < fileList?.length; i++) {
      const file = fileList.item(i);
      files.push(file)
    }
    return files
  }

  onMouseOver(event) {
    try {
      this.isHovered = true;
      if (this.pinDragDropService.isDragging) {
        return;
      }
      if (this.pinDragDropService.dragFault !== this.fault) {
        const e: HTMLElement = event.srcElement;
        if (e?.classList?.contains('fault-tile')) {
          this.pinDragDropService.registerFaultDrag(this.fault, e);
        }
      }

    } catch (ex) {
      console.error(ex);
    }
  }

  onMouseLeave(event) {
    this.isHovered = false;
  }

  async onPress(event) {
    if (!await firstValueFrom(this.selectionService.selectionMode)) {
      this.selectionService.startSelectionMode();
      this.selectionService.selectItem(this.fault);
    } else {
      this.onClick(event);
    }
  }

  // Temporarily prevent click event from firing when working with dev tools
  async onPressUp(event) {
    this.preventClick = true;
    setTimeout(() => this.preventClick = false, 50);
  }

  public async attachToPinData(data: any) {

  }

  //attach to pin in tile viewer pass pin as param and in bim viewer pin-marker
  //since componetn used both for bim and tile popup check need to to be done to make sure we getting pin
  async attachToPin(marker, pinPopupService: PinPopupService): Promise<void> {
    // console.warn(marker, 'attachToPin');
    const pin = marker?.pin ? marker.pin : marker;
    this.pinPopupService = pinPopupService;

    if (!pin.data) {
      // console.warn('attachToPin no data !!!');
      return;
    }
    if (this.fault?.uid === pin?.data?.uid) {
      // console.warn('attachToPin already loaded !!!');
      return;
    }

    // console.warn('attachToPin - ' + marker?.pin?.data?.uid);

    this.fault = pin.data;
    this.sizeMode = SizeModeEnum.Narrow;
    this.initAsPlanViewerPopup = true;

    this.projectLoaderService.fields
      .pipe(untilDestroyed(this),
        filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded),
        map(m => {
          return m.data.filter(x => x.Prop != null).map(x => [x.Prop.toString(), x.Permission]);
        }),
      ).subscribe(param => {
      this.fieldPermDict = Object.fromEntries(param);

      this.ngOnChanges(
        {
          ['fault']: {currentValue: this.fault, previousValue: undefined, firstChange: true} as SimpleChange,
          ['fieldPermDict']: {
            currentValue: this.fieldPermDict,
            previousValue: undefined,
            firstChange: true
          } as SimpleChange,
          ['sizeMode']: {currentValue: this.sizeMode, previousValue: undefined, firstChange: true} as SimpleChange,
          ['isSelected']: {currentValue: false, previousValue: undefined, firstChange: true} as SimpleChange,
          ['isChecked']: {currentValue: false, previousValue: undefined, firstChange: true} as SimpleChange,
          ['selectionMode']: {
            currentValue: this.selectionMode,
            previousValue: undefined,
            firstChange: true
          } as SimpleChange,
          ['initAsPlanViewerPopup']: {
            currentValue: this.initAsPlanViewerPopup,
            previousValue: undefined,
            firstChange: true
          } as SimpleChange
        }
      )
      this.changeDetectorRef.detectChanges();

    });

  }

  lockedMessage() {
    return this.translateService.instant('MM.toolbox.actionDeactivated.locked');
  }

  lockedCountExceeded2(countValue: number) {
    return this.translateService.instant('MM.toolbox.actionDeactivated.faultsCountExceeded2', {count: countValue});
  }
}
